import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=7e1c181a&scoped=true"
import script from "./NotificationEdit.vue?vue&type=script&lang=ts"
export * from "./NotificationEdit.vue?vue&type=script&lang=ts"
import style0 from "./NotificationEdit.vue?vue&type=style&index=0&id=7e1c181a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1c181a",
  null
  
)

export default component.exports